import React from "react";
import { SearchBar } from './search-input/search-bar';
import Img from '../assets/img/main-img-fixauto.jpg';
import ImgMobile from '../assets/img/main-banner-mobile.jpg';

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(() => typeof window !== 'undefined' && window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

export const HomeBanner = ({ onSearch }) => {
  const isMobile = useIsMobile();
  return (
    <div
      className="w-full py-16 px-4 mt-5 flex justify-center items-center bg-no-repeat bg-cover rounded-lg"
      style={{
        backgroundImage: `url(${isMobile ? ImgMobile : Img})`,
        backgroundSize: 'cover',
      }}
    >
      <div className="max-w-3xl mt-3 w-full flex flex-col items-center text-center">
        <div className="mb-8">
          {
            isMobile ? (
            <span className="text-white text-[28px] md:text-[36px] font-bold drop-shadow-lg transition-all duration-300 text-center font-manrope">
              FixAuto
              <span className="block md:inline"> Asistentul tău în drum</span>
            </span>
            ) : (
              <span className="text-white text-[28px] md:text-[46px] font-bold drop-shadow-lg transition-all duration-300 text-center">
                FixAuto -
                <span className="block md:inline"> Asistentul tău în drum</span>
              </span>
            )
          }
        </div>
        <div className="w-full">
          <SearchBar styled={true} onSearch={onSearch} />
        </div>
      </div>
    </div>
  );
};